import { createContext } from 'react';

interface TreeViewContext {
  isDraggingGlobal: boolean;
  getSelected: () => string[];
  onDragStart: () => void;
  onDragEnd: () => void;
}

export default createContext<TreeViewContext>({
  isDraggingGlobal: true,
  getSelected: () => [],
  onDragStart: () => {
    return;
  },
  onDragEnd: () => {
    return;
  },
});
